import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-N",
  "use": "icon-N-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-N\">\n<path d=\"M23.1441 31.384C22.3281 30.616 22.3281 29.272 23.1441 28.456L40.4721 11.176C41.1441 10.504 41.1441 9.4 40.4721 8.728C39.7521 8.056 38.6481 8.056 37.9761 8.728L20.6961 26.008C18.5361 28.168 18.5361 31.72 20.6961 33.88L37.8321 51.016C38.1681 51.352 38.6001 51.544 39.0321 51.544C39.5121 51.544 39.9441 51.352 40.2801 51.016C40.9521 50.344 40.9521 49.24 40.2801 48.52L23.1441 31.384Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol